import React, { useEffect, useState, useRef } from 'react';
import { createUpdateVoucherConfig, fetchVoucherConfigs, updateConfigsData } from './utils';
import AButton from '../../common/form-fields-mui/AButton';
import ListComponent from './ListComponent';
import ALoader from '../../common/a-loader';
import { successToast } from '../../common/utils/methods/toasterFunctions/function';
import FilterForm from './FilterForm';

const VoucherAssignmentConfig = ({
    isPANIndiaConfig,
    dropdownData
}) => {

    const [configsData, setConfigsData] = useState([]);
    const [filterForm, setFilterForm] = useState({});
    const [paginationInfo, setPaginationInfo] = useState({
        totalRecords: 100,
        currPage: 0,
        currPageSize: 10,

    });
    const [loading, setLoading] = useState(false);

    console.log('configsData', configsData);

    const listRef = useRef({});

    const getConfigsData = async ({
        pageNo = paginationInfo?.currPage,
        pageSize = paginationInfo?.currPageSize,
        filters = filterForm,
    }) => {
        try {
            setLoading(true);
            const { businessArea } = dropdownData;
            const req = {
                offset: pageNo,
                pageSize,
                ...filters,
                businessAreaIds: isPANIndiaConfig ? [0] : businessArea?.map(bu => bu?.value)
            }
            const resp = await fetchVoucherConfigs(req);

            if (resp?.code === 200) {
                const { paginatedData, currentPage, totalRecords } = resp?.data;

                const updatedData = updateConfigsData(paginatedData, dropdownData);
                setConfigsData(updatedData);

                setFilterForm(filters);
                setPaginationInfo({
                    totalRecords,
                    currPage: currentPage,
                    currPageSize: pageSize
                })
            }

        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }

    }

    const createUpdateHandler = async (rowForm) => {
        try {
            setLoading(true);
            const resp = await createUpdateVoucherConfig(rowForm, isPANIndiaConfig);
            if (resp?.code === 200) {
                successToast("Request completed successfully!");
                getConfigsData({});
                listRef.current.stopEditing();
            }

        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    }

    const dropdownDataFetched = Object.keys(dropdownData)?.length > 0;

    useEffect(() => {
        (dropdownDataFetched) && getConfigsData({});
    }, [dropdownData])


    return (
        <>
            {(loading || !dropdownDataFetched)  && <ALoader position={"fixed"} />}

            <div className='a-card'>

                <div className='d-flex justify-content-between mb-2'>
                    <h3 className='color-dark mb-0'>{isPANIndiaConfig ? 'PAN India configuration' : 'BU Level configuration'}</h3>


                    <div className='d-flex'>
                        <FilterForm
                            isPANIndiaConfig={isPANIndiaConfig}
                            getConfigsData={getConfigsData}
                        />
                        <AButton
                            variant='primary_filled'
                            size='xs'
                            onClick={() => listRef.current.addNewRow()}
                        >
                            + Add configuration
                        </AButton>
                    </div>

                </div>

                <ListComponent
                    paginationInfo={paginationInfo}
                    rows={configsData}
                    dropdownData={dropdownData}
                    ref={listRef}
                    isPANIndiaConfig={isPANIndiaConfig}
                    createUpdateHandler={createUpdateHandler}
                    getConfigsData={getConfigsData}
                />


            </div>
        </>
    );
}

export default VoucherAssignmentConfig;